import type { PaletteMode } from "@mui/material"

export const light = {
  alternate: {
    main: "#f4fbf8", // surface
    dark: "#e9efec", // surfaceContainer
  },
  cardShadow: "rgba(23, 70, 161, .11)", // Custom shadow color
  mode: "light" as PaletteMode,
  primary: {
    main: "#006b5e", // primary
    light: "#9ff2e1", // primaryContainer
    dark: "#00201b", // onPrimaryContainer
    contrastText: "#ffffff", // onPrimary
  },
  secondary: {
    main: "#236488", // secondary
    light: "#c8e6ff", // secondaryContainer
    dark: "#001e2e", // onSecondaryContainer
    contrastText: "#ffffff", // onSecondary
  },
  text: {
    primary: "#171d1b", // onBackground
    secondary: "#3f4946", // onSurfaceVariant
  },
  divider: "rgba(0, 0, 0, 0.12)", // Divider color
  background: {
    paper: "#ffffff", // surfaceContainerLowest
    default: "#f4fbf8", // surface
    level2: "#eff5f2", // surfaceContainerLow
    level1: "#ffffff", // surfaceContainerLowest
  },
}

export const dark = {
  alternate: {
    main: "#0e1513", // background
    dark: "#090f0e", // surfaceContainerLowest
  },
  cardShadow: "rgba(0, 0, 0, .11)", // Custom shadow color
  common: {
    black: "#000000", // Black
    white: "#ffffff", // White
  },
  mode: "dark" as PaletteMode,
  primary: {
    main: "#83d5c5", // primary
    light: "#9ff2e1", // primaryFixed
    dark: "#005046", // onPrimary
    contrastText: "#003730", // onPrimary
  },
  secondary: {
    main: "#93cdf6", // secondary
    light: "#c8e6ff", // secondaryContainer
    dark: "#004C6D", // onSecondary
    contrastText: "#ffffff", // onSecondary
  },
  text: {
    primary: "#dee4e1", // onBackground
    secondary: "#9DAEA8", // onSurfaceVariant
  },
  divider: "rgba(255, 255, 255, 0.12)", // Divider color
  background: {
    paper: "#1b211f", // surfaceContainerLowest
    default: "#0e1513", // background
    level2: "#171d1b", // surfaceContainerLow
    level1: "#1b211f", // surfaceContainer
  },
}
